import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../../features/auth/services/auth-session.service';
import { AuthConfigService } from '../services/auth-config.service';
import { DEFAULT_CMS_FALLBACK_ROUTE, resolveFirstAccessibleCmsRoute } from '../utils/auth-routing';

export const guestGuard: CanActivateFn = () => {
  const config = inject(AuthConfigService);
  const router = inject(Router);
  const session = inject(AuthSessionService);

  if (!config.enabled || config.bypassLogin) {
    return router.createUrlTree([DEFAULT_CMS_FALLBACK_ROUTE]);
  }

  if (session.isAuthenticated()) {
    const fallbackRoute = config.bypassPermissions
      ? DEFAULT_CMS_FALLBACK_ROUTE
      : resolveFirstAccessibleCmsRoute((permission) => session.hasPermission(permission));

    return router.createUrlTree([fallbackRoute ?? '/acceso-denegado']);
  }

  return true;
};
